import { createFileRoute } from '@tanstack/react-router';

import Profile from '@/modules/profile/pages/Profile';

export const Route = createFileRoute('/_authenticated/_system/profile/')({
  head: () => ({
    meta: [{ title: 'Perfil' }],
  }),
  component: Profile,
});
